import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../utils/common'
import Text from '../../../Text'
import {
  getMatchCoverageText,
  getMatchCriterionLabelKey,
} from '../RentalPortalMatch.utils'
import { RentalPortalMatchCriterionChip } from '../RentalPortalMatchCriterionChip'

import { QA_NAME_MATCH_CHIPS_CELL } from './RentalPortalMatchChipsCell.constants'
import {
  getHasMatchChipsRest,
  getMatchChips,
} from './RentalPortalMatchChipsCell.utils'

import * as styles from './RentalPortalMatchChipsCell.module.css'

function RentalPortalMatchChipsCell({ match }) {
  const { t } = useTranslation()

  const { chips, restCount } = getMatchChips(match)

  return (
    <div
      {...getQaSelector({ value: QA_NAME_MATCH_CHIPS_CELL })}
      className={styles.RentalPortalMatchChipsCell}
    >
      {chips.map(criterion => (
        <RentalPortalMatchCriterionChip
          className={styles.chip}
          criterion={criterion}
          key={criterion.key}
          text={t(getMatchCriterionLabelKey(criterion.key))}
        />
      ))}
      {getHasMatchChipsRest(restCount) ? (
        <Text isSecondary className={styles.rest}>
          {t('RentalPortal.MatchChipsMoreKey', { count: restCount })}
        </Text>
      ) : null}
      <Text isSecondary className={styles.coverage}>
        {getMatchCoverageText(match)}
      </Text>
    </div>
  )
}

export default RentalPortalMatchChipsCell
